import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

const caseImgs = [
  'https://public.readdy.ai/ai/img_res/12f150c43b287dd6ff1a5a91f746173f.jpg',
  'https://readdy.ai/api/search-image?query=Financial%20office%20with%20cybersecurity%20monitoring%20dashboard%20displaying%20network%20security%20status%20firewall%20alerts%20and%20data%20protection%20metrics%20in%20a%20professional%20dark%20themed%20control%20center%20environment&width=600&height=400&seq=case-finance-002&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Smart%20manufacturing%20factory%20floor%20with%20digital%20control%20panels%20ERP%20system%20screens%20showing%20production%20data%20inventory%20management%20and%20automated%20workflows%20in%20a%20clean%20industrial%20setting%20with%20technology%20integration&width=600&height=400&seq=case-mfg-003&orientation=landscape',
];

const caseTagColors = [
  'bg-cyan-500/10 text-cyan-400 border-cyan-500/20',
  'bg-blue-500/10 text-blue-400 border-blue-500/20',
  'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
];

const caseMetricValues = [
  [{ value: '99.8%', mKey: 'case1_m1' }, { value: '60%', mKey: 'case1_m2' }],
  [{ value: '100%', mKey: 'case2_m1' }, { value: '0', mKey: 'case2_m2' }],
  [{ value: '40%', mKey: 'case3_m1' }, { value: '3mo', mKey: 'case3_m2' }],
];

export default function CaseStudies() {
  const { t } = useTranslation();

  const caseKeys = [
    { tagKey: 'case1_tag', titleKey: 'case1_title', descKey: 'case1_desc' },
    { tagKey: 'case2_tag', titleKey: 'case2_title', descKey: 'case2_desc' },
    { tagKey: 'case3_tag', titleKey: 'case3_title', descKey: 'case3_desc' },
  ];

  return (
    <section className="bg-slate-950 py-24" id="case-studies">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-in">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
            <div>
              <span className="text-cyan-400 text-sm font-semibold tracking-widest uppercase">
                {t('cases_badge')}
              </span>
              <h2 className="text-4xl font-bold text-white mt-3 mb-3">{t('cases_title')}</h2>
              <p className="text-slate-400">{t('cases_sub')}</p>
            </div>
            <Link
              to="/case-studies"
              className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              {t('cases_view_all')}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </AnimatedSection>

        <div className="grid lg:grid-cols-3 gap-8">
          {caseKeys.map((c, i) => (
            <AnimatedSection key={c.titleKey} animation="fade-in" delay={i * 0.1}>
              <div className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden hover:border-slate-700 transition-all group">
                <div className="h-48 overflow-hidden">
                  <img
                    src={caseImgs[i]}
                    alt={t(c.titleKey)}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <span className={`inline-block text-xs font-semibold px-3 py-1 rounded-full border mb-4 ${caseTagColors[i]}`}>
                    {t(c.tagKey)}
                  </span>
                  <h3 className="text-white font-bold mb-3 leading-snug">{t(c.titleKey)}</h3>
                  <p className="text-slate-400 text-sm leading-relaxed mb-5">{t(c.descKey)}</p>
                  <div className="flex gap-6 pt-4 border-t border-slate-800">
                    {caseMetricValues[i].map(m => (
                      <div key={m.mKey}>
                        <div className="text-xl font-bold text-cyan-400">{m.value}</div>
                        <div className="text-slate-500 text-xs mt-0.5">{t(m.mKey)}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
